import { render, staticRenderFns } from "./PromotionRowOfferLabelMBRExp.vue?vue&type=template&id=15a66ea2&scoped=true"
import script from "./PromotionRowOfferLabelMBRExp.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotionRowOfferLabelMBRExp.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PromotionRowOfferLabelMBRExp.vue?vue&type=style&index=0&id=15a66ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a66ea2",
  null
  
)

export default component.exports